<template>
  <div>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1"> Objet </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 2" step="2">Commande </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <DepotCommandeObjet
            @onNext="onNext($event)"
            :selectedDemande="demande"
          />
        </v-stepper-content>
        <v-stepper-content step="2">
          <DepotCommandeCommande
            @onSubmit="onSubmit"
            @onPrevious="onPrevious"
          />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import DepotCommandeObjet from "@/components/DepotCommande/DepotCommandeObjet.vue";
import DepotCommandeCommande from "@/components/DepotCommande/DepotCommandeCommande.vue";

import Demande from "@/_models/Demande";

export default {
  name: "DepotCommandeSlider",
  components: {
    DepotCommandeObjet,
    DepotCommandeCommande,
  },
  props: { demande: { type: Object, required: true } },
  data() {
    return {
      e1: 1,
      data: [],
    };
  },

  methods: {
    onNext(stepData) {
      this.e1++;
      this.data.push(stepData);
    },

    onPrevious() {
      this.e1--;
      this.data.splice(0);
    },

    async onSubmit(stepData) {
      this.data.push(stepData);
      //requete POST

      const commandeFiles = {
        main: stepData.fichierCommande,
        additional: stepData.fichierComplementaire,
      };
      const commande = {
        demande: this.demande["@id"],
        numero: stepData.numeroCommande,
        createdAt: stepData.dateCommande,
        montant: parseFloat(stepData.montantCommande),
        active: true,
        files: commandeFiles,
      };

      const newCommande = await Demande.addDocument("commandes", commande);
      let type = "success",
        message;

      if (newCommande.error) {
        message = newCommande.message;
        type = "error";
      } else {
        message = "la commande a été enregistrée";
      }
      this.$store.dispatch("Notification/show_message", { type, message });
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>